/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IFamilias from './entidades/familias';
import IFiltrosFamilia from './entidades/filtrosFamilia';

export default class ModeloFamilias {
    public consultarFamilias() {
        return manejadorRest<IRespuesta<IFamilias>>(() => negocioConfiguracion.get('Familia/ConsultarListaFamilia'), true);
    }
    public crearFamilias(familias: IFamilias) {
        return manejadorRest<IRespuesta<IFamilias>>(() => negocioConfiguracion.post('Familia/GuardarFamilia', familias), true);
    }
    public editarFamilias(familias: IFamilias) {
        return manejadorRest<IRespuesta<IFamilias>>(() => negocioConfiguracion.put('Familia/EditarFamilia', familias), true);
    }
    public eliminarFamilias(familias: IFamilias) {
        return manejadorRest<IRespuesta<IFamilias>>(() => negocioConfiguracion.delete('Familia/EliminarFamilia', familias), true);
    }
    public consultarListaFamiliasPorFiltro(filtrosFamilia: IFiltrosFamilia) {
        return manejadorRest<IRespuesta<IFamilias>>(
            () => negocioConfiguracion.post('Familia/ConsultarListaFiltro', filtrosFamilia),
            true
        );
    }
}
